// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  googleMapsKey: 'AIzaSyAWmDdSmAUZjZ42jEIom43mBGmUFXDgA-g',
  firebase: {
    apiKey: 'AIzaSyBFXRldLw2cqCGRg5E8qcLgoIjIVCEOoCA',
    authDomain: 'salto-25b3e.firebaseapp.com',
    databaseURL: 'https://salto-25b3e.firebaseio.com',
    projectId: 'salto-25b3e',
    storageBucket: '<your-storage-bucket>',
    messagingSenderId: '<your-messaging-sender-id>'
  }
};



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/environments/environment.ts